import { createSlice } from "@reduxjs/toolkit";
import { createEmailTemplateAPI } from "../../services/createEmailTemplate";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const createEmailTemplateSlice = createSlice({
  name: "createEmailTemplate",
  initialState: data,
  reducers: {
    createEmailTemplateInfo(state) {
      state.isLoading = true;
    },
    createEmailTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    createEmailTemplateFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    createEmailTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const createEmailTemplateHandler = (data) => async (dispatch) => {
  try {
    dispatch(createEmailTemplateAction.createEmailTemplateInfo());
    const response = await createEmailTemplateAPI(data);
    dispatch(createEmailTemplateAction.createEmailTemplateSuccess(response));
  } catch (e) {
    dispatch(createEmailTemplateAction.createEmailTemplateFailure(e));
  }
};
export default createEmailTemplateSlice.reducer;
export const createEmailTemplateAction = createEmailTemplateSlice.actions;
